import React from 'react'

export default function SettingsInnerStyle({signed_in}) {
  let settings_buttons = null
  if (signed_in !== 'admin') {
    settings_buttons = {
      warehouses_display: (signed_in.user_access.settings_warehouses) ? 'flex' : 'none',
      vat_display: (signed_in.user_access.settings_vat) ? 'flex' : 'none',
      npos_accounts_settings_display: (signed_in.user_access.settings_npos_accounts_settings) ? 'flex' : 'none'
    }
  } else {
    settings_buttons = {
      warehouses_display: 'flex',
      vat_dispaly: 'flex',
      npos_accounts_settings_display: 'flex'
    }
  }

  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        :root {
          --light: #555;
        }

        .settings-container {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: 1fr;
          overflow: auto;
          padding: 0px 30px;
        }

        .settings-item-wrapper {
          border: none;
          background-color: lightskyblue;
          display: flex;
          flex-direction: column;
          margin: 10px;
        }
        .settings-item-title, .settings-item-description {
          padding: 10px;
        }
        .settings-item-title { font-size: 1.2rem; }
        .settings-item-description {
          font-size: 0.95rem;
          color: var(--light, #555);
        }

        .settings-item-wrapper:hover, .settings-item-wrapper:focus {
          /* let's change the ---light here so settings-item-description is also affected by hover */
          transform: scale(1.0003);
          box-shadow: 1px 1px 2px 1px #BBB;
          border: none;
          background-color: blue;
          color: white;
          outline: none;
          --light: white;
        }

        /** Settings Buttons **/
        #warehouses-button { display: ${settings_buttons.warehouses_display} }
        #vat-button { display: ${settings_buttons.vat_display} }
        #npos-accounts-settings-button { display: ${settings_buttons.npos_accounts_settings_display} }
      `}
      </style>
    </React.Fragment>
  )
}
